import React, { useContext, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
  // useNavigate,
  // useLocation
} from 'react-router-dom';
// import Context, { IContext } from '../../context/Context';
// import { toast } from 'react-toastify';
// import Cookies from 'js-cookie';

import ErrorPage from '../../pages/ErrorPage';

import Header from '../Header';
import Home from '../../pages/Home';
import Controle from '../../pages/Controle';
import AgendarCompromisso from '../../pages/AgendarCompromisso';

function LayoutFixo() {
  return (
    <>
      <Header />
      <Outlet />
    </>
  );
}

export default function RouterComponent() {
  return (
    <>
      <Router>
        <Routes>
          <Route element={<LayoutFixo />}>
            <Route path='/' element={<Home />} />
            <Route path='/controle' element={<Controle />} />
            <Route path='/agendarCompromisso' element={<AgendarCompromisso />} />
          </Route>
          <Route path='*' element={<ErrorPage />} />
        </Routes>
      </Router>
    </>
  );
}
